import React from "react";
import {} from "../redux/actions";
import { connect } from "react-redux";
import { selectAgendaForFocussedDay } from "../redux/selectors";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import Avatar from "@material-ui/core/Avatar";
import WorkIcon from "@material-ui/icons/Work";
import Build from "@material-ui/icons/Build";
import LocalShipping from "@material-ui/icons/LocalShipping";
import Person from "@material-ui/icons/Person";
import Divider from "@material-ui/core/Divider";

class OverviewList extends React.Component {
    render() {
        return (
            <List>
                {null ||
                    this.props.agenda.map((j, i) => {
                        return (
                            <React.Fragment key={i}>
                                <ListItem key={i}>
                                    <Avatar>
                                        <WorkIcon />
                                    </Avatar>
                                    <ListItemText primary={j.name} />
                                </ListItem>
                                <Divider inset />

                                <List component="div" disablePadding>
                                    {j.tasks.map((t, iii) => {
                                        return (
                                            <ListItem key={iii}>
                                                <ListItemText
                                                    primary={t.name}
                                                    secondary={`${t.start_date}-${t.end_date}`}
                                                />
                                            </ListItem>
                                        );
                                    })}
                                </List>
                                <Divider />

                                <Collapse in={true} timeout="auto" unmountOnExit>
                                    {j.children.map((c, ii) => {
                                        return (
                                            <React.Fragment key={ii}>
                                                <List inset="true" component="div" disablePadding>
                                                    <ListItem>
                                                        <Avatar>
                                                            {c.type === "employees" && <Person />}
                                                            {c.type === "equipment" && <Build />}
                                                            {c.type === "machines" && (
                                                                <LocalShipping />
                                                            )}
                                                        </Avatar>
                                                        <ListItemText primary={c.name} />
                                                    </ListItem>
                                                </List>
                                                <Divider inset />

                                                <List component="div" disablePadding>
                                                    {c.tasks.map((t, iii) => {
                                                        return (
                                                            <ListItem key={iii}>
                                                                <ListItemText
                                                                    primary={t.name}
                                                                    secondary={`${t.start_date}--${
                                                                        t.end_date
                                                                    }`}
                                                                />
                                                            </ListItem>
                                                        );
                                                    })}
                                                </List>
                                                <Divider />
                                            </React.Fragment>
                                        );
                                    })}
                                </Collapse>
                                <Divider />
                            </React.Fragment>
                        );
                    })}
            </List>
        );
    }
}

export default connect(
    store => {
        return { agenda: selectAgendaForFocussedDay(store) };
    },
    {}
)(OverviewList);
